import React from 'react';

import { Container } from 'common/components/Layout/Layout';

import TextBlock from 'common/components/Placeholder/components/TextBlock/TextBlock';
import ContentBar from 'common/components/Placeholder/components/ContentBar/ContentBar';

import styles from './ChoosenCompanyPlaceholder.module.scss';

const ChoosenCompanyPlaceholder = () => (
  <div className={styles.CompanyCardContainer}>
    <div className={styles.CompanyCard}>
      <div className={styles.CompanyCardContent}>
        <ContentBar className={styles.CompanyLogo} />
        <TextBlock color={styles.PlaceholderDefaultColor} rows={6} />
      </div>
    </div>
    <ContentBar className={styles.CompanyBackgroundImage} />
    <ContentBar className={styles.CompanyBackgroundInfo} />
    <Container>
      <div className={styles.CompanyInfo}>
        <div className={styles.CompanyInfoDescription}>
          <TextBlock 
            color={styles.PlaceholderDefaultColor} 
            rows={6}
            className={styles.ContentBox}
          />
        </div>
        <div className={styles.CompanyInfoImageBox}>
          <ContentBar className={styles.CompanyInfoImage} />
        </div>
      </div>
    </Container>
  </div>
);

export default ChoosenCompanyPlaceholder;


// WEBPACK FOOTER //
// ./src/views/ChoosenCompany/placeholder/ChoosenCompanyPlaceholder.js